import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  // Carry the query string across the redirect. An ad lands on a protected URL, and a bare
  // createUrlTree(['/login']) would drop `gclid` from the address bar before GTM's Conversion
  // Linker — which reads the URL only once the container has loaded — ever sees it.
  return auth.isAuthenticated() ? true : router.createUrlTree(['/login'], { queryParams: route.queryParams });
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAuthenticated() ? router.createUrlTree(['/recruitment/roles']) : true;
};
